var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "additional-fields d-none" }, [
    _c(
      "div",
      {
        staticClass: "add-field-btn cursor-pointer",
        class: _vm.showAdditionalFields ? "active" : "",
        on: { click: _vm.showFieldList }
      },
      [
        _c("img", {
          staticClass: "exclude-outside-click",
          attrs: { src: require("@/csmworkflow/img/plus.svg") }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.outside,
            expression: "outside"
          },
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showAdditionalFields,
            expression: "showAdditionalFields"
          }
        ],
        staticClass: "fields"
      },
      [
        _c("h3", [_vm._v("Fields")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            {
              staticClass: "field-items cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.newField("user")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-users" }),
              _vm._v(" User\n          ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "field-items cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.newField("status")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-info-circle" }),
              _vm._v(" Status\n          ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "field-items cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.newField("status_note")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-comments" }),
              _vm._v(" Long Text\n          ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "field-items cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.newField("due_date")
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-calendar" }),
              _vm._v(" Datepicker\n          ")
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }